<style scoped>
.stats-info-header {
  font-size: 16px;
  color: var(--color-text-dark);
  font-weight: bold;
  /*margin-bottom: 20px;*/
  text-align: right;
  width: 120px;
  padding-right: 5px;
  vertical-align: center;
}
.stats-info-value {
  font-size: 18px;
  /*text-align: left;*/
  /*padding-left: 20px;*/
}
.stats-info-table {
  /*margin-bottom: 15px;*/
  /*margin: 0 auto;*/
  height: 40px;
  width: 100%;
  text-align: left;
}
.red {
  color:var(--color-danger-light);
}
.green {
  color: var(--color-success-light);
}
.stats-info-box {
  height: 260px;
}
td {
  /*border: 1px solidvar(--color-danger-light);*/
}
.stats-type-name {
  margin-right: 5px;
  margin-left: 15px;
  /*color: var(--color-text-dark);*/
  /*font-weight: bold;*/
}
.stats-type-switch-box {
  display: flex;
  align-items: center
}
div {
  /*border: 1px solid pink;*/
}
.download-report-icon {
  opacity: 0.7;
  cursor: pointer;
  color: #6b74e7;
}

.download-report-icon:hover {
  opacity: 1;
}

.number-of-stats {
  font-size: 16px;
  /*margin-top: 3px;*/
}

.hint-icon {
  color: grey;
  padding-bottom: 3px;
}
.hint-icon:hover {
  color: darkgrey;
}

.statstableheader {
  width: 120px;
  color: var(--color-text-dark);
  font-weight: bold;
}

.statstablelefthead {
  text-align: right;
  padding-right: 10px;
  color: var(--color-text-dark);
  font-weight: bold;
}

.statstablecell {
  /*width: 100px;*/
  font-size: 18px;
}
.statstabletotal {
  /*width: 100px;*/
  font-size: 24px;
}

.statstablerow {
  height: 40px;
}

hr {
  border: 1px solid var(--color-background);
  border-top: none;
}

@media all and (max-width: 650px) {
  .stats-info-box {
    height: 285px;
  }
}
</style>

<template>
  <div class="stats-info-box box symbbox">
    <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 30px">
      <div>
        <RadioGroup v-model="interval"  type="button" @on-change="updateDates">
          <Radio label="1" style="font-size: 12px">{{ $text.tr('СЕГОДНЯ') }}</Radio>
          <Radio label="7" style="font-size: 12px">7 {{ $text.tr('ДНЕЙ') }}</Radio>
          <Radio label="30" style="font-size: 12px">30 {{ $text.tr('ДНЕЙ') }}</Radio>
          <Radio label="90" style="font-size: 12px">90 {{ $text.tr('ДНЕЙ') }}</Radio>
        </RadioGroup>
      </div>
      <div style="margin-left: 20px">
        <DatePicker v-model="$store.state.statsdata.Dates" style="font-size: 14px; width: 230px" type="daterange" placement="bottom-end" format="dd.MM.yyyy" :placeholder="$text.tr('Выбрать период')" @on-clear="datePickerClear" @on-change="datePickerChange"></DatePicker>
      </div>
      <div style="margin-left: 20px">
        <Icon class="download-report-icon" size="36" :title="$text.tr('Скачать') + ' .csv'" type="ios-download-outline" @click="downloadReport"/>
      </div>
    </div>
    <div style="display: flex; justify-content: center;">
      <table>
        <tr>
          <td class="statstableheader"></td>
          <td class="statstableheader"></td>
          <td class="statstableheader">{{ $text.tr('ЗАВЕРШЕНО')}}</td>
          <td class="statstableheader">{{ $text.tr('ОРДЕРА')}}</td>
          <td class="statstableheader">{{ $text.tr('ОБОРОТ')}}</td>
          <td class="statstableheader">{{ $text.tr('PNL')}}</td>
        </tr>
        <tr class="statstablerow">
          <td class="statstablelefthead">{{ $text.tr('СДЕЛКИ')}}</td>
          <td style="text-align: left">
            <i-switch v-model="$store.state.statsdata.TradeStat" @on-change="$store.state.statsdata.LoadingTrades = true; statTypeChanged()"/>
          </td>
          <td>
            <div class="statstablecell" v-if="$store.state.statsdata.TradeStat && !$store.state.statsdata.LoadingTrades">{{ statsdata2.Trades.Pos + statsdata2.Trades.Neg }} [<span class="green">{{ statsdata2.Trades.Pos }}</span>/<span class="red">{{ statsdata2.Trades.Neg }}</span>]</div>
          </td>
          <td class="statstablecell" v-if="$store.state.statsdata.TradeStat && !$store.state.statsdata.LoadingTrades">{{ statsdata2.Trades.Orders }}</td>
          <td class="statstablecell" v-if="$store.state.statsdata.TradeStat && !$store.state.statsdata.LoadingTrades">${{ statsdata2.Trades.Volume }}</td>
          <td class="statstablecell" :class="{'red' : parseFloat(statsdata2.Trades.PNL) < 0, 'green':  parseFloat(statsdata2.Trades.PNL) > 0}" v-if="$store.state.statsdata.TradeStat && !$store.state.statsdata.LoadingTrades">{{ statslib.profitDollarSign(statsdata2.Trades.PNL) }}</td>
        </tr>
        <tr v-if="$store.state.sys.tradeExchange.ExchId !== 'BIF'" class="statstablerow">
          <td class="statstablelefthead">{{ $text.tr($store.state.sys.tradeExchange.ExchId === 'BYF' || $store.state.sys.tradeExchange.ExchId === 'GEF' ? 'GRIDS' : 'БОТЫ')}}</td>
          <td style="text-align: left">
            <i-switch v-model="$store.state.statsdata.BotStat" @on-change="$store.state.statsdata.LoadingBots = true; statTypeChanged()"/>
          </td>
          <td>
            <div v-if="$store.state.sys.tradeExchange.ExchId !== 'BYF' && $store.state.sys.tradeExchange.ExchId !== 'GEF' && $store.state.statsdata.BotStat && !$store.state.statsdata.LoadingBots" class="statstablecell">{{ statsdata2.Bots.Pos + statsdata2.Bots.Neg }} [<span class="green">{{ statsdata2.Bots.Pos }}</span>/<span class="red">{{ statsdata2.Bots.Neg }}</span>]</div>
          </td>
          <td class="statstablecell" v-if="$store.state.statsdata.BotStat && !$store.state.statsdata.LoadingBots">{{ statsdata2.Bots.Orders }}</td>
          <td class="statstablecell" v-if="$store.state.statsdata.BotStat && !$store.state.statsdata.LoadingBots">${{ statsdata2.Bots.Volume }}</td>
          <td class="statstablecell" :class="{'red' : parseFloat(statsdata2.Bots.PNL) < 0, 'green':  parseFloat(statsdata2.Bots.PNL) > 0}" v-if="$store.state.statsdata.BotStat && !$store.state.statsdata.LoadingBots">{{ statslib.profitDollarSign(statsdata2.Bots.PNL) }}</td>
        </tr>
        <tr v-if="$store.state.sys.tradeExchange.ExchId === 'BIF'" class="statstablerow">
          <td class="statstablelefthead">BOOSTERS</td>
          <td style="text-align: left">
            <i-switch v-model="$store.state.statsdata.BoosterStat" @on-change="$store.state.statsdata.LoadingBots = true; statTypeChanged()"/>
          </td>
          <td>
            <div class="statstablecell" v-if="$store.state.statsdata.BoosterStat && !$store.state.statsdata.LoadingBoosters">{{ statsdata2.Boosters.Pos + statsdata2.Boosters.Neg }} [<span class="green">{{ statsdata2.Boosters.Pos }}</span>/<span class="red">{{ statsdata2.Boosters.Neg }}</span>]</div>
          </td>
          <td class="statstablecell" v-if="$store.state.statsdata.BoosterStat && !$store.state.statsdata.LoadingBoosters">{{ statsdata2.Boosters.Orders }}</td>
          <td class="statstablecell" v-if="$store.state.statsdata.BoosterStat && !$store.state.statsdata.LoadingBoosters">${{ statsdata2.Boosters.Volume }}</td>
          <td class="statstablecell" :class="{'red' : parseFloat(statsdata2.Boosters.PNL) < 0, 'green':  parseFloat(statsdata2.Boosters.PNL) > 0}" v-if="$store.state.statsdata.BoosterStat && !$store.state.statsdata.LoadingBoosters">{{ statslib.profitDollarSign(statsdata2.Boosters.PNL) }}</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td colspan="3"><hr></td>
        </tr>
        <tr class="statstablerow">
          <td class="statstablelefthead"></td>
          <td></td>
          <td></td>
          <td class="statstabletotal">{{ statsdata2.Total.Orders }}</td>
          <td class="statstabletotal">${{ statsdata2.Total.Volume }}</td>
          <td class="statstabletotal" :class="{'red' : parseFloat(statsdata2.Total.PNL) < 0, 'green':  parseFloat(statsdata2.Total.PNL) > 0}">{{ statslib.profitDollarSign(statsdata2.Total.PNL) }}</td>
        </tr>
      </table>
    </div>
<!--    <div>-->
<!--      <div v-if="$store.state.statsdata.TradeStat">{{ $text.tr('СДЕЛОК') }} {{ $store.state.stats.PositiveTrades + $store.state.stats.NegativeTrades }} [{{ $store.state.stats.PositiveTrades }}/{{ $store.state.stats.NegativeTrades }}]</div>-->
<!--      <div v-if="$store.state.sys.tradeExchange.ExchId !== 'BIF' && $store.state.statsdata.BotStat">{{ $text.tr('БОТОВ') }} 0 [0/0]</div>-->
<!--      <div v-if="$store.state.sys.tradeExchange.ExchId === 'BIF' && $store.state.statsdata.BoosterStat">BOOSTERS 0 [0/0]</div>-->
<!--    </div>-->
<!--    <div style="display: flex; justify-content: center; align-items: center;  width: 100%; margin-bottom: 15px" v-if="0">-->
<!--      <table class="stats-info-table">-->
<!--        <tr>-->
<!--          <td class="stats-info-header" style="width: 50%">-->
<!--            <Tooltip :delay="500" max-width="230" placement="right">-->
<!--              <Icon class="hint-icon" size="18" type="ios-information-circle-outline"></Icon>-->
<!--              <div slot="content">{{ $text.tr('В статистике учитываются: завершенные сделки, выключенные боты, остановленные бустеры') }}</div>-->
<!--            </Tooltip>-->
<!--            {{ $text.tr('ОБЩИЙ PNL')}}-->
<!--          </td>-->
<!--          <td class="stats-info-value" :class="{'red' : parseFloat(statsdata.TotalPNL) < 0, 'green':  parseFloat(statsdata.TotalPNL) > 0}">${{ statsdata.TotalPNL }}</td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td class="stats-info-header">{{ $text.tr('ОБЪЕМ')}}</td>-->
<!--          <td class="stats-info-value">${{ statsdata.Volume }}</td>-->
<!--        </tr>-->
<!--      </table>-->
      <!--      <div style="display: flex; justify-content: center; align-items: center;">-->
      <!--        <div class="stats-info-header">{{ $text.tr('ОБЩИЙ PNL')}}</div>-->
      <!--        <div class="stats-info-value" :class="{'red' : parseFloat(statsdata.TotalPNL) < 0, 'green':  parseFloat(statsdata.TotalPNL) > 0}">${{ statsdata.TotalPNL }}</div>-->
      <!--      </div>-->
      <!--      <div style="display: flex; justify-content: center; align-items: center">-->
      <!--        <div class="stats-info-header">{{ $text.tr('ОБЪЕМ')}}</div>-->
      <!--        <div class="stats-info-value">${{ statsdata.Volume }}</div>-->
      <!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { StatsData } from '../../../util/types'
import stats from '@/services/stats'

@Component({
  components: {
  }
})
export default class StatsInfo extends Vue {
  interval = '30'
  get statsdata () {
    // @ts-ignore
    return (this.$store.state.stats as StatsData)
  }

  get statsdata2 () {
    return this.$store.state.stats
  }

  get statslib () {
    return stats
  }

  statTypeChanged () {
    // console.log('stat type changed, update statistics...')
    stats.updateStats()
  }

  datePickerClear () {
    // console.log('date picker clear')
    this.interval = '30'
    const d = new Date()
    d.setHours(0, 0, 0, 0)
    const intervalInMilisec = 86400000 * 29
    // @ts-ignore
    this.$store.state.statsdata.Dates = [new Date(d - intervalInMilisec), d]
  }

  datePickerChange () {
    // console.log('date picker changed')
    const d = new Date()
    d.setHours(0, 0, 0, 0)
    const intervalInMilisec = 86400000 * 29
    // @ts-ignore
    const lastWeekDates = [new Date(d - intervalInMilisec), d]
    // console.log('last week dates', lastWeekDates)
    if (this.$store.state.statsdata.Dates.length > 1 && (this.$store.state.statsdata.Dates[0].getTime() !== lastWeekDates[0].getTime() ||
      this.$store.state.statsdata.Dates[1].getTime() !== lastWeekDates[1].getTime())) {
      this.interval = '-'
    }
  }

  updateDates () {
    // console.log('updateDates')
    const d = new Date()
    d.setHours(0, 0, 0, 0)
    const intervalInMilisec = 86400000 * (parseInt(this.interval) - 1)
    // @ts-ignore
    this.$store.state.statsdata.Dates = [new Date(d - intervalInMilisec), d]
  }

  downloadReport () {
    stats.downloadReport()
  }
}
</script>
